<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12" class="mt-1">
        <div class="dispatch-table">
          <b-card>
            <div slot="header">
              <span>Fleet Registry - Warehouse</span>
              <a
                href="#"
                class="btn btn-sm btn-info float-right ml-1"
                id="printpagebutton"
                @click="onPrint"
              >
                <i class="fa fa-print"></i> Print
              </a>
              <button
                id="printexportout"
                class="btn btn-sm btn-info float-right"
                @click="onexport"
              >
                Export
              </button>
            </div>
            <b-row>
              <b-col md="3" class="my-1">
                <!--<b-progress height="2px" :value="progressCap" variant="primary" class="mt-2"></b-progress>-->
                <b-form-group label-cols-sm="1" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Search.." />
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''"
                        >Clear</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> </b-row
            >&nbsp;
            <b-row class="float-right">
              <b-col md="2">
                <i @click="onfilter" class="fa fa-lg fa-filter clickable"></i>
              </b-col>
            </b-row>
            <br />
            <br />
            <!-- <div class="table-responsive" style="height:300px; overflow:auto;"> -->
            <b-table
              show-empty
              bordered
              responsive="sm"
              stacked="md"
              hover
              small
              striped
              head-variant="light"
              :busy.sync="isBusy"
              :items="warehouse"
              :fields="fields"
              :filter="filter"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:cell(Dwell_Time)="data">
                 {{ data.item.Dwell_Day }} {{ data.item.Dwell_Time }}
              </template>
              <template v-slot:cell(ishit)="data">
                <i
                  :class="parseInt(data.item.Dwell_Minute) < dwellTimeWarehouse
                  //  data.item.ishit == 1
                      ? 'activeStatus icon-check active_icon'
                      : 'inactiveStatus icon-close inactive_icon'
                  "
                ></i>
              </template>
            </b-table>
            <!-- </div> -->
            <b-modal
              centered
              title="FILTER DATA"
              id="modal-sm"
              size="sm"
              v-model="onviewModal"
              @ok="onfiltersearch"
            >
              <div class="px-5">
                <b-form-group>
                  <label for="remarks">From</label>
                  <input class="form-control" type="date" v-model="arrival" />
                  <!-- <datetime type="date" week-start="7" class="form-control" v-model="startdate" value-zone="local" zone="local"></datetime> -->
                </b-form-group>
                <b-form-group>
                  <label for="remarks">To</label>
                  <input class="form-control" type="date" v-model="departure" />
                  <!-- <datetime type="date" week-start="7" class="form-control" v-model="endDate" value-zone="local" zone="local"></datetime> -->
                </b-form-group>
              </div>
            </b-modal>
            <div style="margin-top: 5px">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
              >
              </b-pagination>
            </div>
          </b-card>
          <br />
        </div>
        <b-modal
          title="System Message"
          v-model="deleteModal"
          @ok="onDeleteItem"
        >
          Are you sure you want to remove
          <strong>{{ selectedItemLabel }} ?</strong>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from "../../services/api";
import JSONToCSVConvertor from "./../../services/JSONToCSVConvertor.js";
import axios from "axios";
import moment from "moment";
export default {
  data: function () {
    return {
      progressCap: null,
      deleteModal: false,
      selectedItem: {},
      selectedItemLabel: "",
      selectedfile: null,
      perPage: this.$store.getters.perPage,
      totalWarehouse: 0,
      currentPage: 1,
      isBusy: false,
      filter: null,
      warehouse: [],
      search: null,
      onviewModal: false,
      dwellTimeWarehouse:0,
      arrival: moment(new Date()).format("YYYY-MM-DD"),
      departure: moment(new Date()).format("YYYY-MM-DD"),
      fields: [
        // {
        //   key: "Action",
        //   sortable: false
        // },
        {
          key: "fleetregistryId",
          label: "ID",
          sortable: true,
        },
        {
          key: "branfleetownerId",
          label: "Trucker ID",
        },
        {
          key: "driver",
          label: "Driver Name",
          sortable: false,
        },
        {
          key: "licenseno",
          label: "License No.",
          sortable: true,
        },
        {
          key: "plateno",
          label: "Plate No.",
          sortable: true,
        },
        {
          key: "refdocument",
          label: "Document",
          sortable: true,
        },
        {
          key: "scancode",
          label: "Scan Code",
          sortable: false,
        },
        {
          key: "remarks",
          label: "Remarks",
          sortable: false,
        },
        {
          key: "arrivaldatetime",
          label: "Arrival Date Time",
          formatter: "DateConvertFooter",
        },
        {
          key: "departuredatetime",
          label: "Departure",
          formatter: "DateConvertFooter",
        },
        {
          key: "ishit",
          label: "HIT/MISS",
        },

       {
          key: "Dwell_Time",
          label: "Days, HH:MM:SS",
        },
      ],
    };
  },

  computed: {
    resultQuery() {
      if (this.search) {
        return this.warehouse.filter((taskList) => {
          return parseInt(taskList.fleetregistryId) == this.search;
        });
      } else {
        return this.warehouse;
      }
    },

    rows() {
      return this.warehouse.length;
    },
  },

  methods: {
    onPrint: function () {
      // this.isHidden = true;
      var printButton = document.getElementById("printpagebutton");
      var printExportout = document.getElementById("printexportout");
      var breadView = document.getElementById("breadview");
      //Set the print button visibility to 'hidden'
      printButton.style.visibility = "hidden";
      printExportout.style.visibility = "hidden";
      breadView.style.visibility = "hidden";
      //Print the page content
      window.print();
      printButton.style.visibility = "visible";
      printExportout.style.visibility = "visible";
      breadView.style.visibility = "visible";
    },

    onexport: function () {
      JSONToCSVConvertor(this.warehouse, "Fleet Registry Report", true);
    },

    onfileselected(event) {
      this.selectedfile = event.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(this.selectedfile);
      reader.onload = function () {
        console.log(reader.result.split(",")[1]);
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },

    onUpload() {
      const imageToUri = require("image-to-uri");
      var imageAsBase64 = imageToUri(this.selectedfile);
      const evt = new FormData();
      evt.append("image", imageAsBase64);
      evt.append("origfilename", this.selectedfile.name);
      evt.append("extension", ".png");
      api.instance
        .post("wfms/UploadCustomerImage", evt, {
          onUploadProgress: (uploadEvent) => {
            this.progressCap = Math.round(
              (uploadEvent.loaded / uploadEvent.total) * 100
            );
          },
        })
        .then((res) => {
          console.log(res);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    onfilter() {
      this.onviewModal = true;
    },

    onfiltersearch() {
      this.isBusy = true;
      var self = this;
      self.$store.commit("setLoading", true);
      axios
        .get(
          self.$store.state.IFMSURLlocal +
            "get-fleet-registry-arrival?brancode=" +
            self.$store.state.selectedWarehouse +
            "&arrival=" +
            self.arrival +
            "&arrivalend=" +
            self.departure
        )
        .then((resp) => {
          self.fleet = resp.data;
          self.total = resp.data.total;
          console.log(this.arrival);
          self.$store.commit("setLoading", false);
          self.isBusy = false;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          self.$store.commit("setLoading", false);
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
    },

    DateConvertFooter(date) {
      if (date !== null) {
        var newDate = date;
        newDate =
          newDate[1] + "-" + newDate[2].substring(0, 2) + "-" + newDate[0];
        return moment(date).format("MM-DD-YYYY, h:mm a");
      }
    },

    getFleetRegistryWarehouse() {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      this.isBusy = true;
      var self = this;
      self.$store.commit("setLoading", true);
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-fleet-registry-warehouse?brancode=" +
            self.$store.state.selectedWarehouse
        )
        .then((resp) => {
          self.warehouse = resp.data;
          self.totalWarehouse = resp.data.totalWarehouse;
          self.$store.commit("setLoading", false);
          self.isBusy = false;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          self.$store.commit("setLoading", false);
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
    },

    onPageSelect(page) {
      this.isBusy = true;
      let self = this;
      self.$store.commit("setLoading", true);
      axios
        .get(
          "wfms/get-fleet-registry-departure-inbound?brancode=" +
            self.$store.getters.selectedWarehouse
        )
        .then((resp) => {
          self.items = resp.data;
          self.totalItem = resp.data.totalItem;
          self.$store.commit("setLoading", false);
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          self.$store.commit("setLoading", false);
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
    },

    onSelecteItemToDelete: function (param) {
      this.selectedItem = param;
      this.selectedItemLabel = this.selectedItem.fleetregistryId;
      this.deleteModal = true;
    },

    onDeleteItem: function () {
      this.$store.commit("setLoading", true);
      axios
        .post(
          this.$store.state.IFMSURL +
            "remove-fleet-registry?fleetregistryId=" +
            this.selectedItem.fleetregistryId
        )
        .then((resp) => {
          //this.initTable();
          this.deleteModal = false;
          this.$store.commit("setLoading", false);
        })
        .catch((error) => {
          this.$store.commit("setLoading", false);
        });
    },
    getData: function () {
      let self = this;
      self.$store.commit("setLoading", true);
      //elf.form.brancode = this.$store.state.selectedWarehouse;
      // console.log(this.$store.state.selectedWarehouse);

      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-site-config?branchcode=" +
            this.$store.state.selectedWarehouse
        )
        .then((resp) => {
          if (resp.data != null) {
            self.form = resp.data;
            this.dwellTimeWarehouse = self.form.WarehouseDwell
          //  console.log(self.form);
            this.selected =
              self.form.Status == null || self.form.Status == "Active  "
                ? "Active"
                : self.form.Status;
          }
          // self.$store.commit("setLoading", false);
        })
        .catch((err) => {
          api.httpMsg(self, err.status, err.data);
          this.$store.dispatch("logout").then(() => {
            localStorage.removeItem("vuex");
            localStorage.removeItem("token");
            this.$router.push("/login");
          });
          self.$store.commit("setLoading", false);
        });
    },
    
  },

  created: function () {
    this.getFleetRegistryWarehouse();
    this.arrival = moment(new Date()).format("YYYY-MM-DD");
    this.departure = moment(new Date()).format("YYYY-MM-DD");
  },
};
</script>